import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import getFunzionario from "../services/getFunzionario";
import editFunzionario from "../services/editFunzionario";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class EditFunzionario extends React.Component {
    constructor(props){
        super (props)

        this.state = {
            nome: '',
            cognome: ''
        };

    }

    async componentDidMount() {

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });    

        let current = cookies.get('funzionario', { path: '/' });
        let funzionario = await getFunzionario(username, token, current);

        this.setState({ nome: funzionario.nome, cognome: funzionario.cognome });
    }

    render () {

        return (
        <>
            <PageTitle title={'Modifica funzionario'} />  

            <TextInput name='Nome' value={this.state.nome} 
                onChange={(text) => { this.setState({nome: text})}
            } />

            <TextInput name='Cognome' value={this.state.cognome} 
                onChange={(text) => { this.setState({cognome: text})}
            } />

            <div style={{ height: 30 }}></div>

            <FixButton title={'Salva'} callback={() => this.save()} />
        </>
        );
    }

    async save() {

        this.setState({ isLoading: true });
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        if (!this.state.nome) {
            alert('Inserire un nome valido');
            return;
        }

        if (!this.state.cognome) {
            alert('Inserire un cognome valido');
            return;
        }

        let funzionario = {
            id: cookies.get('funzionario', { path: '/' }), 
            nome: this.state.nome, 
            cognome: this.state.cognome, 
        };

        let res = await editFunzionario(username, token, funzionario);
        if (res.result === 'ok') {
            window.location.href = '/#/app/funzionari';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la modifica del funzionario. Per favore, riprova.');
    }

}
